<template>
  <div></div>
</template>

<script>

export default {
  created() {
    this.$router.push({ name: 'homePage' });
  }
}
</script>
